var Editor = require('./Editor');
var $ = require('jQuery');
var XssFilter = require('../../../../lib/XssFilter');
var util = require('../../../global/utils');
var IEVersion = util.IEVersion()
var html2Text = require('../../../utils/html2Text');
var RichText = function (options) {
    var defaults = {
        template: '<div class="im-input-richtext" contenteditable="true" style="height: 100%;overflow: auto;"></div>'
    };
    $.extend(defaults, options);
    Editor.call(this, defaults);
};

RichText.prototype = Object.create(Editor.prototype);
RichText.prototype.clear = function () {
    this._element.html('');
    this.focus();
};
RichText.prototype.get = function () {
    return {
        type: 'text',
        msg: this._element.html()
    };
};
RichText.prototype.update = function (value, options) {
    var is_emotion = options && options.is_emotion;
    var oldValue = this.get().msg;
    //兼容IE
    var need_html_2 = is_emotion || (options && options.need_html_2);
    if(IEVersion !== -1){
        oldValue = oldValue == '<br>' ? '': oldValue;
    }
    // xssFilter,将'<'替换成’&lt;将'>'替换成&gt;
    var newValue = XssFilter.doFilter(oldValue + (need_html_2 ? value : html2Text(value)));
    this._element.html(newValue);
    this.focus();
};
RichText.prototype.inputChange = function (value) {
    this.triggerEvent('inputChange', value);
};
RichText.prototype.inputKeyUp = function (value) {
    this.triggerEvent('inputKeyUp', value);
};
RichText.prototype.keyboard_output = function (e) {
    this.triggerEvent('keyboardOutput', e);
};
module.exports = RichText;
